import React, { useEffect, useRef, useState } from "react";

export default function Counter({ to = 0, suffix = "", duration = 1600 }) {
    const [val, setVal] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        const obs = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !started.current) {
                    started.current = true;
                    const start = performance.now();
                    const tick = (now) => {
                        const p = Math.min(1, (now - start) / duration);
                        const eased = 1 - Math.pow(1 - p, 3);
                        setVal(Math.round(eased * to));
                        if (p < 1) requestAnimationFrame(tick);
                    };
                    requestAnimationFrame(tick);
                }
            },
            { threshold: 0.3 }
        );
        if (ref.current) obs.observe(ref.current);
        return () => obs.disconnect();
    }, [to, duration]);

    return (
        <span ref={ref}>
            {val.toLocaleString("en-IN")}
            {suffix}
        </span>
    );
}
